import {useEffect, useState} from "react";
import {EditEpisode} from "./EditEpisode";
import {useEpisodes} from "../../hooks/UseEpisodes";
import {EmptyEpisodes} from "./EmptyEpisode";

export function EditEpisodes(props) {
    const user = props.user;
    const serialId = props.serialId;
    const episodesHook = useEpisodes();
    const [episode, setEpisode] = useState();

    useEffect(() => {
        if (serialId) episodesHook.loadEpisodes(user.token, serialId);
    }, [serialId, user.token]);

    useEffect(() => {
        if (!episodesHook.episodes) return;

        setEpisode({
            url: 'https://t.me/fanvoxua_video/',
            uhdFileUrl: '',
            uhdVideoUrl: '',
            name: `Епізод ${episodesHook.episodes.length + 1} -`,
            serialOrder: episodesHook.episodes.length
        });
    }, [episodesHook.episodes?.length]);

    if (!episodesHook.episodes) return <div style={{ padding: '20px', textAlign: 'center' }}>Завантаження серій...</div>;

    const onSaveClicked = async (episodeData) => {
        const cleanedData = {
            ...episodeData,
            name: episodeData.name?.replace(/[\s-]+$/, ''),
            uhdFileUrl: episodeData.uhdFileUrl || null,
            uhdVideoUrl: episodeData.uhdVideoUrl || null
        };

        if (cleanedData.id) {
            await episodesHook.updateEpisode(user.token, serialId, cleanedData);
            alert('Епізод оновлено');
        } else {
            await episodesHook.createEpisode(user.token, serialId, cleanedData);
            alert('Епізод додано');
        }
    };

    const onDeleteClicked = async (episodeData) => {
        await episodesHook.deleteEpisode(user.token, serialId, episodeData);
        alert('Епізод видалено');
    };

    const episodesElements = episodesHook.episodes
        .sort((a, b) => b.serialOrder - a.serialOrder)
        .map(ep => (
            <EditEpisode
                key={ep.id}
                episode={ep}
                onSaveClicked={onSaveClicked}
                onDeleteClicked={onDeleteClicked}
            />
        ));

    return (
        <div style={{ width: '100%' }}>
            {/* New episode form */}
            <div style={{
                backgroundColor: '#eff6ff',
                padding: '15px',
                borderRadius: '12px',
                marginBottom: '20px',
                border: '1px solid #bfdbfe'
            }}>
                <span style={{ display: 'block', marginBottom: '10px', fontWeight: '700', color: '#1e40af' }}>
                    ➕ Додати нову серію
                </span>
                <EmptyEpisodes key={'empty-episode'} episode={episode} onSaveClicked={onSaveClicked}/>
            </div>

            {/* List of existing episodes */}
            <div style={{ maxHeight: '750px', overflowY: 'auto', paddingRight: '5px' }}>
                {episodesElements.length > 0 ? (
                    episodesElements
                ) : (
                    <div style={{ textAlign: 'center', color: '#9ca3af', padding: '20px' }}>
                        Епізодів поки немає. Скористайтеся формою вище, щоб додати перший!
                    </div>
                )}
            </div>
        </div>
    );
}